import React from "react";
import Head from "next/head";

import Navbar from "../../components/Navbar";
import ContactForm from "../../components/ContactForm";
import Footer from "../../components/Footer";

import { Container } from "../../styles/pages/courses/index.styles";

function nrs() {
  return (
    <>
      <Head>
        <title> Normas Regulamentadoras - Astrobyte</title>
      </Head>
      <Navbar />

      <Container>
        <h1> Normas Regulamentadoras (NRs)</h1>
        <hr />
        <p>
         As Normas Regulamentadoras podem ser definidas como o conjunto de disposições e procedimentos técnicos relacionados à segurança e saúde do trabalhador em determinada atividade ou função. Entre seus maiores objetivos estão:  Instruir os empregados e empregadores a respeito das devidas precauções que devem ser tomadas a fim de evitar acidentes de trabalho ou doenças ocupacionais, preservar e promover a integridade física do trabalhadores e também estabelecer a regulamentação pertinente à segurança e saúde do trabalho.
        </p>
        

        <div className="row row-cols-1 row-cols-md-2 g-4">
        <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  NR05 - Comissão Interna de Prevenção de Acidentes
                </h5>
                {/* <p className="card-text">
                  <small className="text-muted">Carga horária: 40 Horas</small>
                </p> */}
                <p
                  className="card-text"
                  style={{
                    color: "var(--color-success)",
                    fontSize: "15px",
                    marginBottom: "15px",
                  }}
                >
                  Vagas Abertas
                </p>
                <p className="card-text">
                O objetivo principal da CIPA é a prevenção de acidentes e doenças decorrentes da vida e a promoção da saúde do trabalhador, observando de forma contínua as condições de trabalho em todos os ambientes de uma empresa.</p>

<p className="card-text">Para o sucesso da comissão e o alcance dos objetivos é necessário a participação e o comprometimento de todos, empregados e empregador. Além disso, o empregador deve disponibilizar recursos suficientes para que o trabalho da CIPA seja realizado. Não criando empecilhos para o trabalho dos cipistas.
                </p>
              </div>
              <a
                href="https://wa.me/5535987073219"
                className="card-footer callToAction"
              >
                Saiba Mais
              </a>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  NR06 - Equipamento de Proteção Individual (EPI)
                </h5>
                {/* <p className="card-text">
                  <small className="text-muted">Carga horária: 40 Horas</small>
                </p> */}
                <p
                  className="card-text"
                  style={{
                    color: "var(--color-success)",
                    fontSize: "15px",
                    marginBottom: "15px",
                  }}
                >
                  Vagas Abertas
                </p>
                <p className="card-text">
                A Norma Regulamentadora de número 6 é uma disposição que versa a respeito da segurança e da medicina do trabalho. A NR 6 estabelece um conjunto de regras para a utilização de EPIs nas empresas, a fim de assegurar a proteção dos trabalhadores durante sua jornada laboral.</p>

<p className="card-text"> A NR 6 define obrigações, direitos e deveres de empregadores e empregados para que os colaboradores resguardem sua saúde, segurança e integridade. A norma estabelece, por exemplo, como os equipamentos devem ser escolhidos e a necessidade de fiscalizar o uso.</p>
              </div>
              <a
                href="https://wa.me/5535987073219"
                className="card-footer callToAction"
              >
                Saiba Mais
              </a>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  NR10 - Segurança em instalação e serviços em Eletricidade
                </h5>
                <p className="card-text">
                  <small className="text-muted">Carga horária: 40 Horas</small>
                </p>
                <p
                  className="card-text"
                  style={{
                    color: "var(--color-success)",
                    fontSize: "15px",
                    marginBottom: "15px",
                  }}
                >
                  Vagas Abertas
                </p>
                <p className="card-text">
                  Neste curso você aprenderá os principais temas que a norma NR
                  10 abrange, desde os cuidados e riscos que a eletricidade
                  possui (como os arcos elétricos), como também os tipos de
                  choques e inclusive todas as medidas de controle de risco
                  elétricos existentes. Com certeza, um curso que será bem
                  proveitoso para o seu currículo.
                </p>
              </div>
              <a
                href="https://wa.me/5535987073219"
                className="card-footer callToAction"
              >
                Saiba Mais
              </a>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  NR18 - Condições e Meio Ambiente de Trabalho na Indústria da
                  Construção
                </h5>
                <p className="card-text">
                  <small className="text-muted">Carga horária: 08 Horas</small>
                </p>
                <p
                  className="card-text"
                  style={{
                    color: "var(--color-success)",
                    fontSize: "15px",
                    marginBottom: "15px",
                  }}
                >
                  Vagas Abertas
                </p>
                <p className="card-text">
                  Esse curso tem como objetivo habilitar e capacitar os
                  trabalhadores da Indútria da Contrução, seguindo as
                  regulamentações contidas na NR18 e melhores práticas
                  existentes, a fim de prevenir a ocorrência de acidentes no
                  decorrer da execução de suas atividades.
                </p>
              </div>
              <a
                href="https://wa.me/5535987073219"
                className="card-footer callToAction"
              >
                Saiba Mais
              </a>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">
                  NR33 - Segurança em Trabalhos Confinados
                </h5>
                <p className="card-text">
                  <small className="text-muted">Carga horária: 40 Horas</small>
                </p>
                <p
                  className="card-text"
                  style={{
                    color: "var(--color-success)",
                    fontSize: "15px",
                    marginBottom: "15px",
                  }}
                >
                  Vagas Abertas
                </p>
                <p className="card-text">
                  Esse curso te mostrará quais são os requisitos mínimos para
                  identificação de espaços confinados e o reconhecimento,
                  avaliação, monitoramento, e controle dos riscos existentes de
                  forma a garantir permanentemente a segurança e saúde dos
                  trabalhadores que interagem direta ou indiretamente nestes
                  espaços.
                </p>
              </div>
              <a
                href="https://wa.me/5535987073219"
                className="card-footer callToAction"
              >
                Saiba Mais
              </a>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h5 className="card-title">NR35 - Trabalho em Altura</h5>
                <p className="card-text">
                  <small className="text-muted">
                    Carga horária: 08 Horas - Curso dias de sábado e domingo
                  </small>
                </p>
                <p
                  className="card-text"
                  style={{
                    color: "var(--color-success)",
                    fontSize: "15px",
                    marginBottom: "15px",
                  }}
                >
                  Vagas Abertas
                </p>
                <p className="card-text">
                  Esse curso te mostrará quais são os requisitos mínimos de
                  proteção para o trabalho em altura, envolvendo o planejamento,
                  a organização e a execução. Ou seja, ela garante a segurança e
                  a saúde dos trabalhadores envolvidos direta ou indiretamente
                  com trabalhos em altura.
                </p>
              </div>
              <a
                href="https://wa.me/5535987073219"
                className="card-footer callToAction"
              >
                Saiba Mais
              </a>
            </div>
          </div>
        </div>
        <div>
          <br />
          <br />
          <br />
          <br />
          <h1>
            {" "}
            Entre em contato conosco e inicie uma nova jornada na sua carreira
          </h1>
          <br />
          <ContactForm />
        </div>
      </Container>
      <Footer />
    </>
  );
}

export default nrs;
